"use client";
import React, { memo } from "react";
import { Tab, TabProps } from "@mui/material";

const AppTab = ({ sx, ...otherProps }: TabProps) => {
  return (
    <Tab
      sx={{
        textTransform: "unset",
        color: "common.black",
        padding: "6px 16px",
        minHeight: "unset",
        ...sx,
      }}
      disableRipple
      {...otherProps}
    />
  );
};

export default memo(AppTab);
